import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { PlatformService } from '../../services/platform.services';
import { CookieService } from '../../services/cookie.service';
import { API } from '../../utils/api/api.service';

import {
  FEEDBACK_CONTENT,
  FEEDBACK_JOURNEY_CES_ITEM,
  FEEDBACK_JOURNEY_EMOSCORE_ITEM,
} from './feedback-journey.constant';
import { TNK_FEEDBACK_FIRST_LOAN_COOKIE } from '../../shared/constants/cookies-name.constant';
import { FIRST_LOAN_SUCCESS_ROUTE } from '../../shared/constants/route-url.constant';

import { GeneralBantuanResponse } from './feedback-journey.model';
export class FeedbackJourneyComponent {
   media: string;
   journeyPoint: string;
   onCloseFeedback: EventEmitter<any> = new EventEmitter();
public cesPoint: number = 0;
public emoScorePoint: number = 0;
public reasonForm: FormGroup;
public isBusy: boolean = false;
public isSended: boolean = false;
public isError: boolean = false;
public isDismissed: boolean = false;
public isEmoScoreOnly: boolean = false;
public FEEDBACK_CONTENT = FEEDBACK_CONTENT;
public FEEDBACK_JOURNEY_CES_ITEM = FEEDBACK_JOURNEY_CES_ITEM;
public FEEDBACK_JOURNEY_EMOSCORE_ITEM = FEEDBACK_JOURNEY_EMOSCORE_ITEM;
/**
 * @param {?} fb
 * @param {?} api
 * @param {?} router
 * @param {?} platform
 * @param {?} cookies
 */
constructor(
private fb: FormBuilder,
private api: API,
private router: Router,
private platform: PlatformService,
private cookies: CookieService,
  ) {}
/**
 * @return {?}
 */
ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.buildForm();
      this.checkUserSendedFeedback();
      this.checkCesOrEmoContent(this.journeyPoint);
    }
  }
/**
 * \@description To check whether user already submitted feedback journey
 * @return {?}
 */
private checkUserSendedFeedback(): void {
    if (
      this.router.url.includes(FIRST_LOAN_SUCCESS_ROUTE) &&
      this.cookies.get(TNK_FEEDBACK_FIRST_LOAN_COOKIE)
    ) {
      this.isSended = true;
    }
  }
/**
 * \@description Initialize Form Group for reason content
 * @return {?}
 */
private buildForm(): void {
    this.reasonForm = this.fb.group({
      content: new FormControl(''),
    });
  }
/**
 * \@description Method for handling click CES and CSAT Emotion score
 * @param {?} event
 * @return {?}
 */
public handleClickPoint(event): void {
    const { name, value } = event.target.dataset;
    this[name] = parseInt(value);
  }
/**
 * @param {?} type
 * @return {?}
 */
private checkCesOrEmoContent(type: string) {
    if (this.FEEDBACK_CONTENT[`${type}`].ces === null) {
      this.isEmoScoreOnly = true;
    }
  }
/**
 * \@description Method to handle preventDefault and stopPropagation on Mobile Site so modal not closed when user cliked on Feedback Item
 * @param {?} event
 * @return {?}
 */
public handleClickPropagation(event) {
    event.preventDefault();
    event.stopPropagation();
  }
/**
 * \@description To handle submit feedback journey
 * @return {?}
 */
public handleSubmit(): void {
    this.isBusy = true;

    const /** @type {?} */ data = {
      ces_id: this.cesPoint,
      emoscore_id: this.emoScorePoint,
      description: this.reasonForm.value.content || '-',
      page_url: this.router.url,
      page_name: document.title || 'Tunaiku',
      browser_name: navigator.userAgent,
      journey_point: this.journeyPoint,
      submitted_at: new Date(),
      topbar_id: 1,
      version_code: '0',
      version_name: '0',
      media: this.media || null,
    };

    this.api.postToGeneralBantuan(data).subscribe(
      (data: GeneralBantuanResponse) => {
        this.isBusy = false;
        this.isSended = true;
        this.setCookieFeedbackSubmitted();
      },
      (err: HttpErrorResponse) => {
        this.isBusy = false;
        this.isError = true;
      },
    );
  }
/**
 * @return {?}
 */
private setCookieFeedbackSubmitted(): void {
    if (this.router.url.includes(FIRST_LOAN_SUCCESS_ROUTE)) {
      this.cookies.set(TNK_FEEDBACK_FIRST_LOAN_COOKIE, true);
    }
  }
/**
 * \@description To handle on user submit then error, and user want to fill feedback journey again
 * @return {?}
 */
public handleSubmitAgain(): void {
    this.isError = false;
  }
/**
 * \@description To handle on user submit then error, and user want to dismissed
 * @return {?}
 */
public handleDismiss(): void {
    this.isDismissed = true;
    // This is to handle if feedback is on Dialog Modal, we emit event to the Parent Component and Parent will close the Dialog Modal
    this.onCloseFeedback.emit();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  template: `
    <div
      class="feedback"
      *ngIf="!isDismissed"
      (click)="handleClickPropagation($event)"
    >
      <div *ngIf="isSended" class="feedback-message">
        <p>Terima kasih. Saran Anda telah terkirim</p>
      </div>

      <div *ngIf="isError" class="feedback-message">
        <p>
          Maaf, server kami sedang mengalami masalah. Silahkan coba beberapa saat
          lagi
        </p>
        <div class="feedback-message-actions">
          <button
            id="BtnFeedbackActionDismiss"
            class="button-action"
            (click)="handleDismiss()"
          >
            Lewati
          </button>
          <button
            id="BtnFeedbackActionSubmitAgain"
            class="button-action"
            (click)="handleSubmitAgain()"
          >
            Isi Survey Lagi
          </button>
        </div>
      </div>

      <ng-container *ngIf="!isSended && !isError">
        <div class="feedback-header">
          <h2>Survey Kepuasan</h2>
          <div class="feedback-close">
            <button id="BtnFeedbackActionDismissHeader" (click)="handleDismiss()">
              X
            </button>
          </div>
        </div>

        <div class="feedback-body">
          <div *ngIf="!isEmoScoreOnly" class="feedback-item">
            <p class="feedback-description">
              {{ FEEDBACK_CONTENT[journeyPoint].ces.description }}
            </p>
            <div class="feedback-emotion">
              <ul class="feedback-emotion-list">
                <li
                  *ngFor="let item of FEEDBACK_JOURNEY_CES_ITEM"
                  class="feedback-emotion-list-item"
                >
                  <img
                    [src]="item.src"
                    [alt]="item.alt"
                    (click)="handleClickPoint($event)"
                    [attr.data-name]="item.name"
                    [attr.data-value]="item.value"
                    [class.active]="cesPoint === item.value"
                    [id]="item.id"
                  />
                </li>
              </ul>
              <div class="feedback-emotion-text">
                <p class="feedback-emotion-text-low">
                  {{ FEEDBACK_CONTENT[journeyPoint].ces.emotionTextLow }}
                </p>
                <p class="feedback-emotion-text-high">
                  {{ FEEDBACK_CONTENT[journeyPoint].ces.emotionTextHigh }}
                </p>
              </div>
            </div>
          </div>

          <div class="feedback-item">
            <p class="feedback-description">
              {{ FEEDBACK_CONTENT[journeyPoint].emoScore.description }}
            </p>
            <div class="feedback-emotion">
              <ul class="feedback-emotion-list">
                <li
                  *ngFor="let item of FEEDBACK_JOURNEY_EMOSCORE_ITEM"
                  class="feedback-emotion-list-item"
                >
                  <img
                    [src]="item.src"
                    [alt]="item.alt"
                    (click)="handleClickPoint($event)"
                    [attr.data-name]="item.name"
                    [attr.data-value]="item.value"
                    [class.active]="emoScorePoint === item.value"
                    [id]="item.id"
                  />
                </li>
              </ul>
              <div class="feedback-emotion-text">
                <p class="feedback-emotion-text-low">
                  {{ FEEDBACK_CONTENT[journeyPoint].emoScore.emotionTextLow }}
                </p>
                <p class="feedback-emotion-text-high">
                  {{ FEEDBACK_CONTENT[journeyPoint].emoScore.emotionTextHigh }}
                </p>
              </div>
            </div>
          </div>

          <div class="feedback-item">
            <p
              *ngIf="(emoScorePoint === 1 || emoScorePoint === 2) && isEmoScoreOnly"
              class="feedback-description"
            >
              Apa hal yang dapat kami tingkatkan untuk melayani Anda lebih baik?
            </p>
            <p
              *ngIf="
                (emoScorePoint > 2 && isEmoScoreOnly) ||
                !isEmoScoreOnly ||
                emoScorePoint === 0
              "
              class="feedback-description"
            >
              Ceritakan alasan Anda memberikan penilaian tersebut?
            </p>
            <form [formGroup]="reasonForm" method="POST">
              <div class="form-group">
                <textarea
                  formControlName="content"
                  class="form-control"
                  rows="5"
                  placeholder="Tulis alasan Anda disini"
                  id="TxtReasonForm"
                ></textarea>
              </div>
            </form>
          </div>
          <button
            *ngIf="isEmoScoreOnly"
            type="submit"
            class="feedback-button"
            [disabled]="emoScorePoint === 0 || isBusy"
            (click)="handleSubmit()"
            id="BtnSubmitFeedbackJourney"
          >
            Kirim Saran
          </button>
          <button
            *ngIf="!isEmoScoreOnly"
            type="submit"
            class="feedback-button"
            [disabled]="cesPoint === 0 || emoScorePoint === 0 || isBusy"
            (click)="handleSubmit()"
            id="BtnSubmitFeedbackJourney"
          >
            Kirim Saran
          </button>
        </div>
      </ng-container>
    </div>
  `,
  selector: 'feedback-journey',
  styles: [`
    .feedback {
      display: block;
      max-width: 640px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      border: 1px solid #c2c2c2;
      border-radius: 10px;
      color: #535353;
      font-size: 16px;
      text-align: left;
      background-color: #fff; }
      .feedback-message {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        border-radius: 6px;
        -webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
                box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
        background-color: #323232;
        font-family: inherit;
        padding: 15px 20px;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between; }
        @media screen and (max-width: 610px) {
          .feedback-message {
            display: block; } }
        .feedback-message p {
          width: 60%;
          margin: 0;
          color: #fff; }
          @media screen and (max-width: 610px) {
            .feedback-message p {
              width: 100%; } }
        .feedback-message-actions {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex; }
          @media screen and (max-width: 610px) {
            .feedback-message-actions {
              -webkit-box-pack: end;
                  -ms-flex-pack: end;
                      justify-content: flex-end; } }
        .feedback-message .button-action {
          display: inline-block;
          border: 0;
          outline: none;
          background: none;
          color: #81be41;
          font-weight: bold; }
          .feedback-message .button-action:not(:last-child) {
            margin-right: 10px; }
      .feedback-header {
        padding: 15px 20px;
        border-bottom: 1px solid #c2c2c2;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center; }
        @media screen and (max-width: 550px) {
          .feedback-header {
            padding: 10px 15px; } }
        .feedback-header h2 {
          margin: 0;
          margin-right: auto;
          font-family: inherit;
          font-size: 24px;
          font-weight: 700;
          color: #535353; }
          @media screen and (max-width: 550px) {
            .feedback-header h2 {
              font-size: 20px; } }
      .feedback-close button {
        display: block;
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        background: none;
        outline: 0;
        font-size: 18px;
        color: #c2c2c2;
        border: 0; }
      .feedback-body {
        padding: 30px 20px; }
        @media screen and (max-width: 550px) {
          .feedback-body {
            padding: 10px 15px; } }
      .feedback-item {
        margin-bottom: 30px; }
        @media screen and (max-width: 550px) {
          .feedback-item {
            margin-bottom: 0; } }
      .feedback-description {
        font-family: inherit;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 15px;
        color: #535353; }
        @media screen and (max-width: 550px) {
          .feedback-description {
            margin-bottom: 7.5px; } }
      .feedback-emotion {
        display: inline-block; }
        .feedback-emotion-list {
          padding: 0;
          margin-top: 0;
          margin-bottom: 5px; }
          @media screen and (max-width: 550px) {
            .feedback-emotion-list {
              margin-bottom: 0; } }
        .feedback-emotion-list-item {
          list-style: none;
          display: inline-block;
          cursor: pointer; }
          .feedback-emotion-list-item:not(:first-child) {
            margin-left: 10px; }
            @media screen and (max-width: 550px) {
              .feedback-emotion-list-item:not(:first-child) {
                margin-left: 5px; } }
          .feedback-emotion-list-item img {
            -webkit-filter: grayscale(100%);
                    filter: grayscale(100%);
            opacity: 0.5;
            -webkit-transition: 0.2s ease-in-out;
            transition: 0.2s ease-in-out;
            display: block;
            max-width: 52px; }
            .feedback-emotion-list-item img.active {
              opacity: 1;
              -webkit-filter: none;
                      filter: none; }
            @media screen and (max-width: 550px) {
              .feedback-emotion-list-item img {
                max-width: 40px; } }
      .feedback-emotion-text {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        font-size: 14px; }
        .feedback-emotion-text-low, .feedback-emotion-text-high {
          color: #535353;
          margin-bottom: 5px; }
      .feedback-button {
        display: block;
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        padding: 15px 65px;
        background: none;
        border-radius: 5px;
        color: #80bd01;
        border: 1px solid #80bd01;
        outline: 0;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        margin-left: auto;
        margin-right: auto; }
        .feedback-button:disabled {
          color: #cacccf;
          border: 1px solid #cacccf;
          cursor: not-allowed; }
        @media screen and (max-width: 550px) {
          .feedback-button {
            padding: 5px 50px; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: API, },
{type: Router, },
{type: PlatformService, },
{type: CookieService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'media': [{ type: Input },],
'journeyPoint': [{ type: Input },],
'onCloseFeedback': [{ type: Output },],
};
}

function FeedbackJourneyComponent_tsickle_Closure_declarations() {
/** @type {?} */
FeedbackJourneyComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FeedbackJourneyComponent.ctorParameters;
/** @type {?} */
FeedbackJourneyComponent.propDecorators;
/** @type {?} */
FeedbackJourneyComponent.prototype.media;
/** @type {?} */
FeedbackJourneyComponent.prototype.journeyPoint;
/** @type {?} */
FeedbackJourneyComponent.prototype.onCloseFeedback;
/** @type {?} */
FeedbackJourneyComponent.prototype.cesPoint;
/** @type {?} */
FeedbackJourneyComponent.prototype.emoScorePoint;
/** @type {?} */
FeedbackJourneyComponent.prototype.reasonForm;
/** @type {?} */
FeedbackJourneyComponent.prototype.isBusy;
/** @type {?} */
FeedbackJourneyComponent.prototype.isSended;
/** @type {?} */
FeedbackJourneyComponent.prototype.isError;
/** @type {?} */
FeedbackJourneyComponent.prototype.isDismissed;
/** @type {?} */
FeedbackJourneyComponent.prototype.isEmoScoreOnly;
/** @type {?} */
FeedbackJourneyComponent.prototype.FEEDBACK_CONTENT;
/** @type {?} */
FeedbackJourneyComponent.prototype.FEEDBACK_JOURNEY_CES_ITEM;
/** @type {?} */
FeedbackJourneyComponent.prototype.FEEDBACK_JOURNEY_EMOSCORE_ITEM;
/** @type {?} */
FeedbackJourneyComponent.prototype.fb;
/** @type {?} */
FeedbackJourneyComponent.prototype.api;
/** @type {?} */
FeedbackJourneyComponent.prototype.router;
/** @type {?} */
FeedbackJourneyComponent.prototype.platform;
/** @type {?} */
FeedbackJourneyComponent.prototype.cookies;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
